/* eslint-disable */
import * as types from './action_types';
import Immutable from 'immutable';

export const initialState = Immutable.fromJS({
  loading: false,
  error: undefined,
  recommendedUsers: []
});

export const updateRecommendedUsers = (recommendedUsers, slug, followedAt) => {
  return recommendedUsers.toJS().map((recommendedUser) => {
    if (recommendedUser.slug !== slug) {
      return recommendedUser
    }

    // Otherwise, this is the one we want - return an updated value
    return {
      ...recommendedUser,
      followedAt: followedAt
    }
  })
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FOLLOWING_RECOMMENDATIONS_RESET:
      return initialState;
    case types.FOLLOWING_RECOMMENDATIONS_LOADING:
      return state.merge({ loading: true });
    case types.FOLLOWING_RECOMMENDATIONS_LOADED:
      return state.merge({ loading: false, error: undefined, recommendedUsers: action.recommendedUsers })
    case types.FOLLOWING_RECOMMENDATIONS_FOLLOWED:
      return state.merge({ recommendedUsers: updateRecommendedUsers(state.get('recommendedUsers'), action.slug, action.followedAt) });
    case types.FOLLOWING_RECOMMENDATIONS_UNFOLLOWED:
      return state.merge({ recommendedUsers: updateRecommendedUsers(state.get('recommendedUsers'), action.slug, undefined) })
    case types.FOLLOWING_RECOMMENDATIONS_ERROR:
      return state.merge({ error: action.error.toString(), loading: false });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/stores/follow_recommendation/reducer.js